/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import './NoData.scss';
import './Error.scss';
import { IErrorProps } from './IErrorProps';

const NoData = (props: IErrorProps) => {
  const { message } = props;
  return (
    <React.Fragment>
      <div className="emaas-error-container">
        <div className="no-data-container">
          <h1 className="desc">{message}</h1>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NoData;
